import { DrEntity } from './dr-entity';
import { DrObjectType, DrObject } from './dr-object';
import { View } from './view';

export class DynamicFolderViewModel extends DrObject {
    model: Partial<DynamicFolder>;

    constructor(value?: Partial<DynamicFolder>) {
        super(DrObjectType.DYNAMIC_FOLDER);
        if (value) {
            this.model = value;
        }
    }
}

export class DynamicFolder extends DrEntity {
    name: string;
    description: string;
    color: string;
    numberOfRules: number;
    outOfDate: boolean;
    archived: boolean;
    iconClass: string;
    iconColor: string;
    view: View;

    // off-model display values
    createdOn: number;
    documentCount: number;
    sampleSetCount: number;
    isBusy: boolean;
    visibleSwitchDisabled: boolean;

    constructor(value?: Partial<DynamicFolder>) {
        super(value);
        if (value) {
            if (value.view) {
                value.view = new View(value.view);
                value.documentCount = value.view.documentCount;
                value.sampleSetCount = value.view.sampleSetCount;
                value.createdOn = value.view.createdOn;
            }
            Object.assign(this, value);
            this.iconClass = 'fa-folder';
            this.iconColor = this.color;
        }
    }
}
